import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquibutton',
	templateUrl:'./JQUIButtonPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIButtonPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIButtonPluginCompPage
{
	mdContent_1004 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.button.JQUIButton;
\`\`\``;
	mdContent_1005 = `\`\`\`java
JQUIButton()
\`\`\``;
	mdContent_1006 = `\`\`\`java
JQUIButton(String text)
\`\`\``;
	mdContent_1007 = `\`\`\`java
JQUIButton&lt;?&gt; btn = new JQUIButton&lt;&gt;("Save");
btn.getOptions().setIcon("ui-icon-disk");
btn.getOptions().setIconPosition("beginning");
\`\`\``;
}
